<template>
    <div>
        <div class="modal-container has-text-centered">
            <div class="">
                <button id="xButt" class="delete" @click="$emit('close')"></button>
                <div class="bottom10 top30 font17"><img src="@/assets/img/fourDotsLogo.png" width="18"/><span class="left3"> EDIT NOTES</span></div> 
                <textarea id="ta" class="editContextTextArea" v-model="compText" rows="12" ></textarea>
                <div class="top30">
                  
                    
                <button class="button wideButton is-coolGreen" @click="ok">
                    OK
                </button>
                <br>
                <div v-if="callBack" class="top10 cancelButton handCursor" @click="cancel">
                    Cancel
                </div>
                <br>

                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {text: String, callBack: Function},
    data: function(){
        return {
            compText: ''
        }
    },
    mounted: function(){
        document.getElementById('ta').focus()
        this.compText = this.text
    },
    methods: {
      ok: function(){
          if(this.callBack){
            this.callBack(this.compText)
            this.$emit('close')
          }

          
      },
      cancel: function(){
          this.$emit('close')
      }
  
    }

}

</script>


<style scoped>
    #title{
        font-size: 1.5rem;
    }
    .modal-container{
        max-width: 450px;
        max-height: 500px;

    }
    .body-bott{
        position: absolute;
        right: 15px;
        bottom: 20px;
        width: 100%;
    }
    .notification{
        height: 100%;
    }
    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
   

</style>
